/* Selo de desconto no canto dos cartoes de produto, como na
   sylviejacques-boutique.fr. O tema nao tem esse elemento, por isso
   e calculado a partir dos precos ja presentes no cartao. */
(function () {
  function toNumber(txt) {
    if (!txt) return 0;
    var t = txt.replace(/[^0-9.,]/g, '').trim();
    if (t.indexOf(',') > -1 && t.indexOf('.') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (t.indexOf(',') > -1) {
      t = t.replace(',', '.');
    }
    var n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }

  function tagCards(root) {
    var cards = (root || document).querySelectorAll('.product-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var media = card.querySelector('.product-item__image');
      if (!media) continue;

      var nw = card.querySelector('.new-price');
      var old = card.querySelector('.old-price');
      var existing = media.querySelector('.sj-tag');

      if (!nw || !old) {
        if (existing) existing.remove();
        continue;
      }

      var priceNow = toNumber(nw.textContent);
      var priceWas = toNumber(old.textContent);
      if (!priceWas || priceWas <= priceNow) {
        if (existing) existing.remove();
        continue;
      }

      var pct = Math.round(((priceWas - priceNow) / priceWas) * 100);
      var label = '-' + pct + '%';

      if (existing) {
        if (existing.textContent !== label) existing.textContent = label;
        continue;
      }

      var tag = document.createElement('div');
      tag.className = 'sj-tag';
      tag.textContent = label;
      media.appendChild(tag);
    }
  }

  /* O botao do banner apontava para a coleccao "all" (todos os produtos
     numa so grelha). Na referencia leva a pagina de todas as coleccoes.
     So e reescrito quando o destino e mesmo /collections/all, para nao
     interferir se o link for mudado no theme editor. */
  function fixHeroLink() {
    var links = document.querySelectorAll('.slideshow .hero__content a.btn, .index-hero .hero__content a.btn');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (/^\/collections\/all\/?$/.test(href)) {
        links[i].setAttribute('href', '/collections');
      }
    }
  }

  function boot() {
    tagCards();
    fixHeroLink();

    var tries = 0;
    var timer = setInterval(function () {
      tagCards();
      fixHeroLink();
      if (++tries > 12) clearInterval(timer);
    }, 600);

    if (document.body) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () {
          tagCards();
          fixHeroLink();
        }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
